import {useEffect} from 'react';
import {fetchAllChatsForUser} from '../Chatmodules/chatService';

export const useUserChats = (userId, setChatList, setCurrentChatId, setMessages, setCurrentChatTitle) => {
  useEffect(() => {
    const loadChats = async () => {
      const allChats = await fetchAllChatsForUser(userId);
      if (Array.isArray(allChats) && allChats.length > 0) {
        const chatList = allChats.map(chat => ({
          id: chat.id,
          title: chat.title || "Chat sin título",
          messages: chat.messages || []
       }));
        setChatList(chatList);
        const firstChat = chatList[0];
        setCurrentChatId(firstChat.id);
        setMessages(firstChat.messages || []);
        setCurrentChatTitle(firstChat.title || "Nuevo Chat");
     } else {
        setChatList([{id: 'new-chat', title: "Nuevo Chat", messages: []}]);
        setCurrentChatId('new-chat');
     }
   };
    loadChats();
 }, [userId, setChatList, setCurrentChatId, setMessages, setCurrentChatTitle]);
};